<template>
  <div class="evaluate">
    <top></top>

    <div class="main">
      <div class="photo">
        <img :src="teacher.avatar" alt="" />
      </div>
      <p class="name">
        {{ teacher.name }}
      </p>
      <div class="tags">
        <div><img src="../assets/images/123_03.jpg" alt="" /></div>

        <span> {{ teacher.level }}</span>
      </div>

      <p class="explain">
        尊敬的用户您好，您的语音倾诉服务已完成， 请您对本次服务进行评价！
      </p>
      <div class="star">
        <van-rate
          v-model="ratevalue"
          @change="onChange"
          size="0.35rem"
          gutter="0.2rem"
          color="#FF7337"
        />
      </div>
      <!-- <p class="result">{{ result }}</p> -->
      <div class="subrate" @click="subrate">提交</div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue";
import { Toast } from "vant";

export default {
  components: { top },
  data() {
    return {
      ratevalue: 0,
      // result: "",
      teacher: {},
    };
  },

  methods: {
    onChange(ratevalue) {
      //   console.log("当前值：" + ratevalue);
      // if (ratevalue == 1) {
      //   console.log("非常差");
      //   this.result = "非常差";
      // } else if (ratevalue == 2) {
      //   this.result = "不太满意";
      // } else if (ratevalue == 3) {
      //   this.result = "一般";
      // } else if (ratevalue == 4) {
      //   this.result = "满意";
      // } else if (ratevalue == 5) {
      //   this.result = "超赞";
      // }
    },
    subrate() {
      var params = new URLSearchParams();
      let token = localStorage.getItem("users");

      params.append("order_id", this.$route.query.orderid);
      params.append("token", token);
      params.append("score", this.ratevalue);

      this.axios.post("/api/order/evaluate", params).then((res) => {
        console.log(res);

        Toast(res.data.message);
        setTimeout(() => {
          if (res.data.code == 0) {
            this.$router.push("/");
          }
        }, 2000);
      });
    },
  },

  created() {
    this.wxshare.share();

    var params = new URLSearchParams();
    params.append("order_id", this.$route.query.orderid);
    let token = localStorage.getItem("users");
    params.append("token", token);
    this.axios.get("/api/order/detail", { params: params }).then((res) => {
      console.log(res.data.code);
      if (res.data.code != 0) {
        this.$router.push({
          path: "/",
          query: { channel: this.$route.query.channel },
        });
        return;
      }
      console.log(res.data.data.status);
      this.status = res.data.data.status;
      // console.log(res.data.data);
      this.teacher = res.data.data.teacher;
    });
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: calc(100vh - 0.6rem);
  overflow-y: scroll;
  // background-image: url(../assets/images/4567_07.jpg);

  .photo {
    width: 1.54rem;
    height: 1.54rem;
    border-radius: 0.05rem;

    margin: 0.31rem auto 0.15rem;

    border-radius: 0.05rem;
    img {
      width: 1.54rem;
      height: 1.54rem;
    }
  }
  .name {
    text-align: center;
    font-size: 0.2rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #393939;
    line-height: 0.24rem;
  }
  .tags {
    position: relative;
    margin-top: -0.7rem;
    text-align: center;
    padding: 0;
    div {
      // margin-left: 0.12rem;
      display: inline-block;
      height: 0.16rem;
      width: 0.16rem;
      line-height: 0.2rem;
      z-index: 9;

      text-align: center;
      img {
        position: absolute;
        z-index: 9;
        vertical-align: bottom;
        font-size: 0.16rem;
        // margin-top: 0.01rem;
        padding-top: 0.03rem;
        width: 0.17rem;
        height: 0.17rem;
        // line-height: 0.13rem;
        border-radius: 50%;
      }
    }
    span {
      text-align: center;
      margin: auto;
      z-index: 4;
      // width: 0.89rem;
      // height: 0.13rem;
      background: #fdb327;
      border-radius: 0.02rem;
      padding: 0 0.05rem;
      margin-left: 0.05rem;

      //   width: 0.73rem;
      // height: 0.11rem;
      font-size: 0.11rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .explain {
    margin: 0.05rem auto 0;
    width: 2.5rem;
    font-size: 0.13rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #393939;
    line-height: 0.24rem;
  }
  .star {
    margin-top: -0.3rem;
    text-align: center;
  }
  .result {
    text-align: center;
    font-size: 0.18rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #080808;
    line-height: 0.24rem;
  }
  .subrate {
    text-align: center;
    margin: 0.25rem auto 0;
    width: 2.5rem;
    height: 0.45rem;
    background: #fe7879;
    border-radius: 0.23rem;

    font-size: 0.2rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.45rem;
  }
}
</style>
